import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import { getFilters } from "../../../common/config/filters";
import { baseFiltersPropTypeFactory, filtersPropTypeFactory } from "../../../common/constants/proptypes/filtersPropTypes";
import { valuedFilters } from "../../../common/utils/filters";
import { DISCOVER, SEARCH } from "../perspectives";
var facetType = PropTypes.oneOf(['disjunctive', 'conjunctive']);
export default {
  filtersContext: ImmutablePropTypes.contains({
    discoverFacetHrefResolver: PropTypes.func,
    searchFacetHrefResolver: PropTypes.func
  }),
  sortOption: ImmutablePropTypes.contains({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    indexSuffix: PropTypes.func.isRequired,
    exclusions: ImmutablePropTypes.map
  }),
  discoverFilters: discoverFilters,
  facetType: facetType,
  hiddenFilters: ImmutablePropTypes.contains(baseFiltersPropTypeFactory(getFilters(), function (fvt) {
    return fvt;
  }).map(function (pt) {
    return PropTypes.oneOfType([PropTypes.bool, ImmutablePropTypes.setOf(pt)]);
  }).toJS()),
  perspective: PropTypes.oneOf([DISCOVER, SEARCH]),
  processedFacet: ImmutablePropTypes.contains({
    facetProducts: ImmutablePropTypes.listOf(ImmutablePropTypes.contains({
      count: PropTypes.number,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })),
    key: PropTypes.string.isRequired,
    sidebarLabel: PropTypes.string.isRequired,
    topBarLabel: PropTypes.string.isRequired,
    openByDefault: PropTypes.bool,
    primary: PropTypes.bool,
    type: facetType.isRequired
  })
};

function discoverFilters(props) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  return ImmutablePropTypes.contains(filtersPropTypeFactory(getFilters().filter(function (f) {
    return f.get('discoverFilter');
  }), function (f) {
    return f.get('requiredDiscoverFilterWhenNonEmpty') && valuedFilters(props.filters).size;
  }).toJS()).apply(void 0, [props].concat(rest));
}